var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-info'),_c('reviews'),(_vm.mazatlan)?_c('hoozie-rewards-site-description',{staticClass:"my-6"}):_vm._e(),_c('attractions-list'),(!_vm.mazatlan)?_c('pulic-transport'):_vm._e(),(!_vm.mazatlan)?_c('supported-by'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }